// extracted by mini-css-extract-plugin
export var content = "_o4-1";
export var noScroll = "_o4-3";
export var paper = "_o4-0";
export var scrollable = "_o4-2";